export class ApiError extends Error {
  status: number
  details?: unknown
  constructor(message: string, status: number, details?: unknown) {
    super(message)
    this.status = status
    this.details = details
  }
}

type FetchOptions = Omit<RequestInit, 'body'> & { body?: unknown }

async function request<T>(path: string, options: FetchOptions = {}): Promise<T> {
  const { body, headers, ...rest } = options
  const init: RequestInit = {
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      ...(body !== undefined ? { 'Content-Type': 'application/json' } : {}),
      ...headers,
    },
    ...rest,
  }
  if (body !== undefined) init.body = JSON.stringify(body)

  let res: Response
  try {
    res = await fetch(`/api${path}`, init)
  } catch (err) {
    throw new ApiError((err as Error).message || 'network_error', 0)
  }

  const text = await res.text()
  const data: unknown = text ? safeParseJson(text) : null

  if (!res.ok) {
    const errBody = data as { error?: string; message?: string; details?: unknown } | null
    throw new ApiError(
      errBody?.message || errBody?.error || `HTTP ${res.status}`,
      res.status,
      errBody?.details,
    )
  }
  return data as T
}

function safeParseJson(text: string): unknown {
  try {
    return JSON.parse(text)
  } catch {
    return text
  }
}

export const api = {
  get: <T>(path: string) => request<T>(path),
  post: <T>(path: string, body?: unknown) => request<T>(path, { method: 'POST', body }),
  put: <T>(path: string, body?: unknown) => request<T>(path, { method: 'PUT', body }),
  patch: <T>(path: string, body?: unknown) => request<T>(path, { method: 'PATCH', body }),
  delete: <T>(path: string) => request<T>(path, { method: 'DELETE' }),
}
